<template>
  <div class="non-blocking-modal">
    <div class="row mb-2">
      <div class="col">
        <h4>Resend move completion email</h4>
        <div class="l-modal-close"
             @click="sendMovingContractEmail"
        >
          <button class="btn btn-close"><span class="mod-icon-close opacity-50" /></button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="alert-danger border-red p-2 rounded">
          <p>You are about to edit a completed job, this will resend services contract email to the customer.</p>
          <p>Please click “Yes, send email” to approve updates made on the job and send the email to the Customer once you’re done with making changes.</p>
          <p class="strong text-danger">Otherwise, the email will be sent automatically 10 minutes after the last update was made.</p>
        </div>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col">
        <button type="button"
                class="btn btn-primary ld-ext-right w-100"
                @click="sendMovingContractEmail(true)"
        >
          Yes, send email
          <div class="ld ld-ball ld-flip" />
        </button>
        <error-field :errors="errors" field="error" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';

export default {
  name: 'SendEmailConfirmation',
  components: {
    ErrorField,
  },
  props: {
    jobId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    errors: new Errors(),
  }),
  methods: {
    sendMovingContractEmail(immediate = false) {
      if (immediate === true) {
        axios
          .post(`jobs/${this.jobId}/mails/moving-contract`, { send: 'true' })
          .then(() => {
            toastr.success('Successfully resent contract email');
            this.$emit('sent');
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
          });
      } else {
        this.$emit('sent', false);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/modals/SendEmailConfirmation.vue